import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | InvizHer</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to InvizHer homepage to explore programming tutorials and tech projects." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-2xl mx-auto">
            <h1 className="text-8xl md:text-9xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">404</h1>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">Page Not Found</h2>
            <p className="text-xl text-gray-600 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link 
                to="/" 
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                Return to Home
              </Link>
              <Link 
                to="/posts" 
                className="px-8 py-3 border-2 border-blue-600 text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-300"
              >
                Browse Tutorials
              </Link>
            </div>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/posts" className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <h3 className="font-semibold text-lg mb-2 text-gray-800">Posts</h3>
                <p className="text-gray-600 text-sm">Explore programming tutorials</p>
              </Link>
              <Link to="/projects" className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <h3 className="font-semibold text-lg mb-2 text-gray-800">Projects</h3>
                <p className="text-gray-600 text-sm">Check out tech projects</p>
              </Link>
              <Link to="/contact" className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <h3 className="font-semibold text-lg mb-2 text-gray-800">Contact</h3>
                <p className="text-gray-600 text-sm">Get in touch with us</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
